import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-main',
  templateUrl: './main.component.pug',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
